<script>
    import { useSound } from '@vueuse/sound'
    import { inventoryMethods, warehouseMethods } from '@state/helpers'
    import { mapGetters } from 'vuex'
    import { StreamBarcodeReader, ImageBarcodeReader } from 'vue-barcode-reader'
    import beep from '@assets/beep.mp3'
    
    export default {
      name: 'QrCounter',
      components: { StreamBarcodeReader, ImageBarcodeReader },
      setup() {
        const audio = useSound(beep)
        return {
          audio,
        }
      },
      data() {
        return {
          modalQrShow: false,
          serial_input: '',
          lote_input: '',
          infoModal: {
            id: 'info-modal',
            title: '',
            content: '',
            show: false
          },
          tableheadersproducts: [
            { key: 'batch', label: 'Lote:', class: 'ws-100' },
          ],
          items_by_batch: 0,
          batch_found_by_serial: '',
          serial_index: 0,
          serial_found: false,
          item_found_by_serial: '',
          searching_serial: false,
          qr_code: '',
          scan: false,
          qr: {
            text: '',
          },
          countError: 0,
          last_serial_input: '',
          last_lote_input: '',
          manualSerials: [
            'U020693698297',
            'U020743715080',
            '68725+15.0026',
            '2069549+15.5017',
            '2073551+17.50 31',
            '2074393+19.0016',
            '2073596+19.50 43',
            '2074045+20.0025',
            '2074045+20.0026',
            '2074045+20.0027',
            '2074045+20.0031',
            '2074045+20.004',
            '2073598+20.50 57',
            '2073598+20.50 68',
            '2073598+20.50 74',
            '2074048+20.5010',
            '2074048+20.5073',
            '2075038+21.5024',
            '2073603+22.0084',
            '2073604+22.5057',
            '2073604+22.5064',
            '2073604+22.5085',
            '2073604+22.5088',
            '2073605+23.0070',
            '2074096+23.5014',
            '2074096+23.50 45',
            '2074899+24.5006',
            '2072222+26.0015',
            '2075294+26.5035',
            '208013315+30.00',
            '2077078+20.5048',
            '36284+22.5022',
            '2076020+16.5001',
            '2076533+18.5079',
            '2075026+19.5075',
            '2075033+21.0065',
            '2061962+22.0010',
            '2073794+24.00 31',
            '2075922+4.0002',
            '2076310+5.0011',
            '2074830+9.0013',
            '2075535+20.0007',
            '2CM80511',
            '2CM80E81',
            '2CM80M05',
            '2CM902S6',
          ],
          manualSerials: ['U020673608801'],
          manualSerialsCount: 0,
        }
      },
      computed: {
        ...mapGetters({
            own_inventory: 'retina/inventory/own_inventory',
          own_stock: 'retina/inventory/own_stock',
          own_inventory_count_mode: 'retina/inventory/own_inventory_count_mode',
        }),
      },
      methods: {
        ...inventoryMethods,
        ...warehouseMethods,
        onDecode(text) {
          console.log(`Decode text from QR code is ${text}`)
          this.qr.text = text
          this.serial_input = this.qr.text.split(',')[0]
          this.last_serial_input = this.serial_input
          this.audio.play()
          if (this.serial_input) {
            this.addItemInOwnStockBySerialProccess()
          }
        },
        addManualSerial(){
          this.serial_input = this.manualSerials[this.manualSerialsCount];
          this.manualSerialsCount++;
          this.audio.play()
          if(this.manualSerialsCount <= this.manualSerials.length){
            this.addItemInOwnStockBySerialProccess();
          }
        },
        addManualLote(){
          this.lote_input = this.manualLotes[this.manualLotesCount];
          this.manualLotesCount++;
          this.audio.play()
          if(this.manualLotesCount <= this.manualLotes.length){
            this.addItemInOwnStockByLoteProccess();
          }
        },
        onLoaded() {
          // console.log(`Ready to start scanning barcodes`)
          this.scan = true
        },
        resetModalQr() {
          this.scan = false
          this.qr.text = ''
        },
        async addItemInOwnStockByLoteProccess() {
          var regex = /\S/;
          if (!regex.test(this.lote_input)) {
            this.$generate_toast(this, 'danger', 'Agregue un lote valido')
            this.lote_input=''
            return false;
          }
          let context = this
          if (context.lote_input.length > 20){
            // hoya:
            if(context.lote_input.substr(24,2) === '21' && context.lote_input.length === 34){
              context.lote_input = context.lote_input.substr(26)
            // hanita:
            } else if(context.lote_input.substr(37,2) === '21' && context.lote_input.indexOf("240¡") > 0){
              let parts = context.lote_input.substr(39).split('240¡')
              context.lote_input = parts[0].substr(0, parts[0].length-2) + '+' + parts[1].substr(0, parts[1].length-1) + ' ' + parts[0].substr(-2)
              // datamatrix - negative power (march/2023)
            } else if(context.lote_input.substr(24,2) === '21' && context.lote_input.search(/(10[A-Z].*240[-])/) > 0){
              let parts = context.lote_input.substr(26).split(/(10[A-Z].*240[-])/)
              context.lote_input = parts[0] + '-' + parts[2]
            // datamatrix (jan/2023)
            } else if(context.lote_input.substr(24,2) === '21' && context.lote_input.search(/(10[A-Z].*240[+])/) > 0){
              let parts = context.lote_input.substr(26).split(/(10[A-Z].*240[+])/)
              context.lote_input = parts[0] + '+' + parts[2]
            // other QR codes
            } else {
              context.lote_input = context.lote_input.split(',')[0]
            }
          }
          context.lote_input = context.lote_input.replaceAll('¡','+')
          var encontrado = false;
          for (var i = 0; i < this.own_stock.length; i++) {
            if (this.own_stock[i].batch == this.lote_input) {
              encontrado = true;
              break;
            }
          }
          console.log('encontrado:'+encontrado)
          if(!encontrado){
            console.log('encontrado:serial')
            for (var i = 0; i < this.own_stock.length; i++) {
              for (var j = 0; j < this.own_stock[i].item.batchs.length; j++) {
                for (var l = 0; l < this.own_stock[i].item.batchs[j].serials.length; l++) {
                  if (this.own_stock[i].item.batchs[j].serials[l] == this.lote_input) {
                    encontrado = true;
                    break;
                  }
                }
                if (encontrado) {
                    break;
                }
              }
              if (encontrado) {
                  break;
              }
            }
            console.log('encontrado:'+encontrado)
          }
          if(encontrado){
            this.$generate_toast(this, 'error', `Item ya se encuentra agregado en la lista (${this.lote_input})`)
          }else{
            await this.findLote(this.own_inventory, true)
            if (this.serial_found) {
              await this.findLote(this.own_stock)
              await this.findLote(this.own_inventory)
              this.addItemInOwnStockByLote({
                item: this.item_found_by_serial,
                batch: this.batch_found_by_serial,
                assurance: this.batch_found_by_serial,
                serial: this.lote_input,
                count: parseFloat(this.items_by_batch)
              })
              this.$generate_toast(this, 'success', `Item agregado (${this.lote_input})`)
            } else {
              await this.findLote(this.own_stock)
              if (this.serial_found){
                this.addItemInOwnStockByLote({
                  item: {batchs:[{batch:this.lote_input, quantity:0, serials:[]}], reference:this.lote_input},
                  batch: this.lote_input,
                  serial: this.serial_input,
                  assurance: null,
                  count: parseFloat(this.items_by_batch)
                })
                this.$generate_toast(this, 'info', `Item agregado (${this.lote_input})`)
              } else {
                if (this.lote_input == this.last_serial_input) {
                  this.countError += 1
                  if (this.countError > 1) {
                    this.modalQrShow = false
                    this.countError = 0
                    this.lote_input = ''
                  }
                }
                this.addItemInOwnStockByLote({
                  item: {batchs:[{batch:this.lote_input, quantity:0, count:parseFloat(this.items_by_batch), serials:[]}], reference:this.lote_input},
                  batch: this.lote_input,
                  serial: this.lote_input,
                  assurance: null,
                  count: parseFloat(this.items_by_batch)
                })
                this.$generate_toast(this, 'success', `Item agregado (${this.lote_input})`)
              }
            }
          }
          this.lote_input = ''
          this.items_by_batch = 0
          this.infoModal.show=false
        },
        async addItemInOwnStockBySerialProccess() {
          var regex = /\S/;
          if (!regex.test(this.serial_input)) {
            this.$generate_toast(this, 'danger', 'Agregue un serial valido')
            this.serial_input=''
            return false;
          }
          let context = this
          if (context.serial_input.length > 20){
            // hoya:
            if(context.serial_input.substr(24,2) === '21' && context.serial_input.length === 34){
              context.serial_input = context.serial_input.substr(26)
            // hanita:
            } else if(context.serial_input.substr(37,2) === '21' && context.serial_input.indexOf("240¡") > 0){
              let parts = context.serial_input.substr(39).split('240¡')
              context.serial_input = parts[0].substr(0, parts[0].length-2) + '+' + parts[1].substr(0, parts[1].length-1) + ' ' + parts[0].substr(-2)
              // datamatrix - negative power (march/2023)
            } else if(context.serial_input.substr(24,2) === '21' && context.serial_input.search(/(10[A-Z].*240[-])/) > 0){
              let parts = context.serial_input.substr(26).split(/(10[A-Z].*240[-])/)
              context.serial_input = parts[0] + '-' + parts[2]
            // datamatrix (jan/2023)
            } else if(context.serial_input.substr(24,2) === '21' && context.serial_input.search(/(10[A-Z].*240[+])/) > 0){
              let parts = context.serial_input.substr(26).split(/(10[A-Z].*240[+])/)
              context.serial_input = parts[0] + '+' + parts[2]
            // other QR codes
            } else {
              context.serial_input = context.serial_input.split(',')[0]
            }
          }
          context.serial_input = context.serial_input.replaceAll('¡','+')
          var encontrado = false;
          for (var i = 0; i < this.own_stock.length; i++) {
            for (var j = 0; j < this.own_stock[i].item.batchs.length; j++) {
              for (var l = 0; l < this.own_stock[i].item.batchs[j].serials.length; l++) {
                if (this.own_stock[i].item.batchs[j].serials[l] == this.serial_input) {
                  encontrado = true;
                  break;
                }
              }
              if (encontrado) {
                  break;
              }
            }
            if (encontrado) {
                break;
            }
          }
          if(encontrado){
            this.$generate_toast(this, 'error', `Item ya se encuentra agregado en la lista (${this.serial_input})`)
          }else{
            await this.findSerial(this.own_inventory)
            if (this.serial_found) {
              this.findSerial(this.own_stock)
                this.findSerial(this.own_inventory)
                this.addItemInOwnStockBySerial({
                  item: this.item_found_by_serial,
                  batch: this.batch_found_by_serial,
                  assurance: this.batch_found_by_serial,
                  serial: this.serial_input,
                })
                this.$generate_toast(this, 'success', `Item agregado (${this.serial_input})`)
            } else {
              this.findSerial(this.own_stock)
              if (this.serial_found){
                this.addItemInOwnStockBySerial({
                  item: {batchs:[{batch:this.serial_input, quantity:0, serials:[this.serial_input]}], reference:this.serial_input},
                  batch: this.serial_input,
                  serial: this.serial_input,
                  assurance: null,
                })
                this.$generate_toast(this, 'info', `Item agregado (${this.serial_input})`)
              } else {
                if (this.serial_input == this.last_serial_input) {
                  this.countError += 1
                  if (this.countError > 1) {
                    this.modalQrShow = false
                    this.countError = 0
                    this.serial_input = ''
                  }
                }
                this.addItemInOwnStockBySerial({
                  item: {batchs:[{batch:this.serial_input, quantity:0, count:1, serials:[this.serial_input]}], reference:this.serial_input},
                  batch: this.serial_input,
                  serial: this.serial_input,
                  assurance: null,
                })
                this.$generate_toast(this, 'success', `Item agregado (${this.serial_input})`)
              }
            }
          }
          this.serial_input = ''
        },
        findSerial(list) {
          this.searching_serial = true
          this.serial_found = false
          this.batch_found_by_serial = ''
          this.item_found_by_serial = ''
          if (this.serial_input.trim() == '') {
            this.$refs['serial_input'].focus()
            return
          }
          let context = this
          if (context.serial_input.length > 20){
            // hoya:
            if(context.serial_input.substr(24,2) === '21' && context.serial_input.length === 34){
              context.serial_input = context.serial_input.substr(26)
            // hanita:
            } else if(context.serial_input.substr(37,2) === '21' && context.serial_input.indexOf("240¡") > 0){
              let parts = context.serial_input.substr(39).split('240¡')
              context.serial_input = parts[0].substr(0, parts[0].length-2) + '+' + parts[1].substr(0, parts[1].length-1) + ' ' + parts[0].substr(-2)
              // datamatrix - negative power (march/2023)
            } else if(context.serial_input.substr(24,2) === '21' && context.serial_input.search(/(10[A-Z].*240[-])/) > 0){
              let parts = context.serial_input.substr(26).split(/(10[A-Z].*240[-])/)
              context.serial_input = parts[0] + '-' + parts[2]
            // datamatrix (jan/2023)
            } else if(context.serial_input.substr(24,2) === '21' && context.serial_input.search(/(10[A-Z].*240[+])/) > 0){
              let parts = context.serial_input.substr(26).split(/(10[A-Z].*240[+])/)
              context.serial_input = parts[0] + '+' + parts[2]
            // other QR codes
            } else {
              context.serial_input = context.serial_input.split(',')[0]
            }
          }
          context.serial_input = context.serial_input.replaceAll('¡','+')
          // if (this.serial_input.trim() == '') return
          for (let p of list) {
            if(p.batchs){
              p.batchs.find((i) => {
                if (i.serials.length>0){
                  if (i.serials.includes(this.serial_input)) {
                    this.serial_index = i.serials.indexOf(this.serial_input)
                    this.batch_found_by_serial = i.batch
                    this.serial_found = true
                  }
                } else{
                  if (i.batch==this.serial_input) {
                    this.serial_index = 0
                    this.batch_found_by_serial = i.batch
                    this.serial_found = true
                    //i.serials.push(this.serial_input)
                  }
                }
              })
            } else{
              if(p.item){
                p.item.batchs.find((i) => {
                if (Boolean(i.serials))
                  if (i.serials.includes(this.serial_input)) {
                    this.serial_index = i.serials.indexOf(this.serial_input)
                    this.batch_found_by_serial = i.batch
                    this.serial_found = true
                  }
              })
              } else{
                if(p.serial==this.serial_input){
                  this.batch_found_by_serial = this.serial_input
                  this.serial_found = true
                }
              }
            }
            
            if (this.serial_found) {
              this.$refs['serial_input'].focus()
              this.item_found_by_serial = p
              this.searching_serial = false
              break
            }
          }
          this.searching_serial = false
          this.$refs['serial_input'].focus()
        },
        findLote(list, lotes=false) {
          this.searching_serial = true
          this.serial_found = false
          this.batch_found_by_serial = ''
          this.item_found_by_serial = ''
          if (this.lote_input.trim() == '') {
            this.$refs['lote_input'].focus()
            return
          }
          let context = this
          if (context.lote_input.length > 20){
            // hoya:
            if(context.lote_input.substr(24,2) === '21' && context.lote_input.length === 34){
              context.lote_input = context.lote_input.substr(26)
            // hanita:
            } else if(context.lote_input.substr(37,2) === '21' && context.serial_input.indexOf("240¡") > 0){
              let parts = context.lote_input.substr(39).split('240¡')
              context.lote_input = parts[0].substr(0, parts[0].length-2) + '+' + parts[1].substr(0, parts[1].length-1) + ' ' + parts[0].substr(-2)
              // datamatrix - negative power (march/2023)
            } else if(context.lote_input.substr(24,2) === '21' && context.lote_input.search(/(10[A-Z].*240[-])/) > 0){
              let parts = context.lote_input.substr(26).split(/(10[A-Z].*240[-])/)
              context.lote_input = parts[0] + '-' + parts[2]
            // datamatrix (jan/2023)
            } else if(context.lote_input.substr(24,2) === '21' && context.lote_input.search(/(10[A-Z].*240[+])/) > 0){
              let parts = context.lote_input.substr(26).split(/(10[A-Z].*240[+])/)
              context.lote_input = parts[0] + '+' + parts[2]
            // other QR codes
            } else {
              context.lote_input = context.lote_input.split(',')[0]
            }
          }
          context.lote_input = context.lote_input.replaceAll('¡','+')
          // if (this.serial_input.trim() == '') return
          for (let p of list) {
            if(p.batchs){
              p.batchs.find((i) => {
                if (i.serials.length>0 && !lotes){
                  if (i.serials.includes(this.lote_input)) {
                    this.serial_index = i.serials.indexOf(this.lote_input)
                    this.batch_found_by_serial = i.batch
                    this.serial_found = true
                  }
                } else{
                  if (i.batch==this.lote_input) {
                    this.serial_index = 0
                    this.batch_found_by_serial = i.batch
                    this.serial_found = true
                    //i.serials.push(this.lote_input)
                  }
                }
              })
            } else{
              if(p.item){
                p.item.batchs.find((i) => {
                if (Boolean(i.serials))
                  if (i.serials.includes(this.lote_input)) {
                    this.serial_index = i.serials.indexOf(this.lote_input)
                    this.batch_found_by_serial = i.batch
                    this.serial_found = true
                  }
              })
              } else{
                if(p.serial==this.lote_input){
                  this.batch_found_by_serial = this.lote_input
                  this.serial_found = true
                }
              }
            }
            
            if (this.serial_found) {
              this.$refs['lote_input'].focus()
              this.item_found_by_serial = p
              this.searching_serial = false
              break
            }
          }
          this.searching_serial = false
          this.$refs['lote_input'].focus()
        },
        playSound() {
          this.audio.play()
        },
        processInput(value){
          console.log("value: ", value)
        },
        info(item, button) {
          var regex = /\S/;
          if (!regex.test(this.lote_input)) {
            this.$generate_toast(this, 'danger', 'Agregue un lote valido')
            this.lote_input=''
            return false;
          }
          this.infoModal.title = item
          this.infoModal.content = item
          this.infoModal.show = true
          this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        resetInfoModal() {
          this.infoModal.title = ''
          this.infoModal.content = ''
          this.infoModal.show = false
        },
      },
    }
    </script>
    
    <template>
      <div>
        <b-card v-if="own_inventory_count_mode">
          <!-- <b-card-title>Conteo: </b-card-title> -->
          <b-input-group size="sm" class="form-serial-lote">
            <b-input-group-prepend class="lead mr-2">
              Serial:
            </b-input-group-prepend>
            <b-form-input class="input-serial-lote"
              v-model="serial_input"
              autofocus
              ref="serial_input"
              @keyup.enter.prevent="addItemInOwnStockBySerialProccess()"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                @click="addItemInOwnStockBySerialProccess()"
                size="sm"
                variant="outline-info"
              >
                <i class="fas fa-plus"></i>
                Agregar
              </b-button>
              <b-button
                @click="addManualSerial()"
                size="sm"
                class="d-none"
                variant="outline-warning">
                Manual
              </b-button>
            </b-input-group-append>
          </b-input-group>
          
          <b-input-group size="sm" class="pt-3 form-serial-lote">
            <b-input-group-prepend class="lead mr-2">
              Lote:
            </b-input-group-prepend>
            <b-form-input class="input-serial-lote"
              v-model="lote_input"
              autofocus
              ref="lote_input"
              @keyup.enter.prevent="info(lote_input, $event.target)"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                @click="info(lote_input, $event.target)"
                size="sm"
                variant="outline-info"
              >
                <i class="fas fa-plus"></i>
                Agregar
              </b-button>
              <b-button
                @click="addManualLote()"
                size="sm"
                class="d-none"
                variant="outline-warning">
                Manual
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <!-- <b-button
            @click="modalQrShow = !modalQrShow"
            variant="outline-info"
            class="mt-2"
          >
            <i class="fas fa-qrcode"></i>
            Lector QR
          </b-button> -->
          <!-- <b-button variant="outline-primary" @click="playSound()">ply</b-button> -->
        </b-card>
        <!--Modal Count Lotes-->
        <b-modal
          :id="infoModal.id"
          :title="infoModal.title"
          v-model="infoModal.show"
          hide-footer
          @hide="resetInfoModal"
          body-class="p-0"
        >
          <b-table
            class="table-sm"
            stacked
            :fields="tableheadersproducts"
            :items="[infoModal.content]"
          >
            <template v-slot:cell(batch)="row">
              <b-list-group flush>
                <b-list-group-item
                  :key="row.item"
                  class="p-0"
                >
                  <div>
                    Lote: <b-badge variant="secondary">{{ row.item }}</b-badge>
                    <div>
                      <form
                        @submit.prevent="
                          addItemInOwnStockByLoteProccess(row.item, items_by_batch)
                        "
                      >
                        <b-input-group size="sm">
                          <b-form-input
                            v-model="items_by_batch"
                            type="number"
                          ></b-form-input>
                          <b-input-group-append>
                            <!-- {{items_by_batch}} -->
                            <b-button
                              v-b-tooltip.hover.v-primary.bottom="'Pasar a Conteo'"
                              type="submit"
                              variant="link"
                              size="sm"
                              class="ml-1 d-inline align-items-center"
                            >
                              <i class="fas fa-plus-circle mr-1"></i> Contar
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </form>
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </template>
          </b-table>
        </b-modal>
    
        <b-modal v-model="modalQrShow" @hidden="resetModalQr()">
          listo para scanear:
          <b-badge v-if="scan" href="#" variant="success">Listo</b-badge>
          <b-spinner v-else type="grow" label="Loading..."></b-spinner>
    
          <h4> Código QR: </h4>
          <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded">
          </StreamBarcodeReader>
          <div class="row">
            <div class="col-lg-12">
              <b-list-group>
                <b-list-group-item> Codigo: {{ qr.text }} </b-list-group-item>
                <b-list-group-item>
                  Longitud: {{ qr.text.length }}
                </b-list-group-item>
                <b-list-group-item>
                  Serial: {{ qr.text.split(',')[0] }}
                </b-list-group-item>
              </b-list-group>
            </div>
          </div>
        </b-modal>
      </div>
    </template>
    <style>
      .input-serial-lote{
        max-width: 65% !important;
      }
      .form-serial-lote{
        justify-content: flex-end;
      }
    </style>